import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';

export const SharedFilter = ({ setFiltersAndSort, filtersAndSort }) => {
  const options = [
    { value: 'all', label: 'Todas' },
    { value: 'shared', label: 'Compartidas' },
    { value: 'notShared', label: 'No Compartidas' }
  ];
  return (
    <Form.Group>
      <Form.Label>Compartidas</Form.Label>

      <Select
        options={options}
        value={options.find(option => option.value === filtersAndSort.shared)}
        onChange={option =>
          setFiltersAndSort(state => ({
            ...state,
            shared: option?.value
          }))
        }
        isSearchable={false}
      />
    </Form.Group>
  );
};
SharedFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired
};
